import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// Center-text plugin
// const centerTextPlugin: Plugin<"doughnut"> = {
// 	id: "center-text",
// 	afterDraw(chart) {
// 		const { ctx } = chart;
// 		const txt = "€ xxx";
// 		const centerX = chart.getDatasetMeta(0).data[0]?.x ?? chart.width / 2;
// 		const centerY = chart.getDatasetMeta(0).data[0]?.y ?? chart.height / 2;

// 		ctx.save();
// 		ctx.font =
// 			"600 36px system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial";
// 		ctx.fillStyle = "#374151"; // slate-700
// 		ctx.textAlign = "center";
// 		ctx.textBaseline = "middle";
// 		ctx.fillText(txt, centerX, centerY);
// 		ctx.restore();
// 	},
// };

// Example props; you can lift these to component props if needed

export default function DonutChartJS({
	data,
	options,
}: {
	data: any;
	options: any;
}) {
	return (
		<div style={{ width: 210, height: 210 }}>
			<Doughnut data={data} options={options} />
		</div>
	);
}
